const documents = (state = null, action) => {
  switch (action.type) {

    case 'LOAD_DOCMENTS': 
      let documents = {}
      action.snapshot.docs.forEach(doc => {
        documents[doc.id] = doc.data()
      })
      return documents

    default: 
      return state
  }
}
export default documents


// WEBPACK FOOTER //
// ./src/reducers/documents.js